/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import Card from '../../card'
import { ImageInline } from '../../image'
import Paragraph from '../../paragraph'
import VideoWrapper from '../../video-wrapper'
import HubspotComponent from '../../hubspot-component'

import { FlexCols, FlexCol, VStack } from '../../../styles/els'
import { formatImage, resolveButtons } from '../../../lib/helpers'

const Hubspot = (props) => {
  const { heading, text, formId, portalId, ...otherProps } = props

  return (
    <Card color="light2">
      <Paragraph
        heading={heading}
        hTier={3}
        htmlText={text}
        tTier={1}
        tTint={true}
        mCenter={true}
        sx={{
          pb: 7,
        }}
      />
      {portalId && formId ? (
        <HubspotComponent formId={formId} portalId={portalId} />
      ) : null}
    </Card>
  )
}

export default Hubspot
